import {createGlobalStyle} from "styled-components";
import "normalize.css";
import "react-virtualized/styles.css";

import {baseFontFamily, baseFontSize, baseLineHeight, pageBackgroundColour, primaryTextColour} from "./styleConsts";

export default createGlobalStyle`
    .tim-of-the-future-root {
        display: flex;
        height: 100%;
    }
    
    html {
        height: 100%;
    }

    body {
        height: 100%;
        
        background-color: ${pageBackgroundColour};
        font-family: ${baseFontFamily};
        font-size: ${baseFontSize}px;
        color: ${primaryTextColour};
        line-height: ${baseLineHeight};
        
        button, input, optgroup, select, textarea {
            font-family: ${baseFontFamily};
            font-size: ${baseFontSize}px;
        }
        /* Remove scroll on the body when react-modal is open */
        &.ReactModal__Body--open {
            overflow: hidden;
        }
        
        .ReactModal__Overlay {
            z-index: 100;
        }
    }
    
    .ant-tooltip {
        max-width: 280px;
        
        .ant-tooltip-content {
            font-size: 12px;
        }
    }
    
    .t-formatted-tooltip {
        .ant-tooltip-content {
            background: white;
            border: 1px solid #d6d0c8;
        }
        
        .ant-tooltip-inner {
            padding: 8px 16px;
            background: white;
            color: black;
        }
    }
    
    .ReactVirtualized__Grid {
        :focus {
            outline: none;
        }
    }
    
    .ReactVirtualized__Table__row {
        :focus {
            outline: none;
        }
    }
`;
